import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Heading from '../../../../generic-components/Heading';
import { Avatar, AvatarSize } from '../../../../DesignSystem/VendorProfile/Avatar';
import Button from '../../../../generic-components/Button';
import RadioButton from '../../../../generic-components/RadioButton';
import { ReactComponent as RightArrow } from '../../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { AccountantAccountSwitcherMode, ClientData } from './types';

interface IProps {
  client: ClientData;
  isChecked?: boolean;
  itemMode: AccountantAccountSwitcherMode;
  onAcceptInvitationClick?: (clientData: ClientData) => void;
  isLoading?: boolean;
  onSelectClient?: (clientData: ClientData) => void;
}

export const AccountantClientItem = ({
  client,
  isChecked,
  itemMode,
  onAcceptInvitationClick,
  isLoading,
  onSelectClient,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <Button
      avoidStopPropagation
      id='client-item'
      onClick={(e) => {
        e.stopPropagation();
        if (onSelectClient) onSelectClient(client);
      }}
      title=''
      className='w-full'
      childElement={
        <div
          className={`flex flex-row py-[16px] items-center transition-all ease-out justify-between rounded-[8px] ${!client.needAccept && itemMode === AccountantAccountSwitcherMode.ONBOARDING ? 'hover:px-[24px]' : ''} ${!client.needAccept && 'hover:bg-bw02'} ${itemMode === AccountantAccountSwitcherMode.PROFILE ? 'px-[24px]' : ''} `}
        >
          <div className='flex items-center gap-[14px]'>
            <div className='relative'>
              <Avatar name={client.clientBusinessName || 'B'} id={client.clientId} size={AvatarSize.LARGE} />
              {client.needAccept && (
                <div className='w-[12px] h-[12px] rounded-[50%] border-bw01 border-[2px] bg-red02 right-0 top-[-2px] absolute ' />
              )}
            </div>
            <div className='grow'>
              {client.needAccept && client.expireDate && (
                <Heading
                  title={`Expire on: ${client.expireDate}`}
                  className='text-[14px] text-left text-bw07 font-metricR'
                />
              )}
              <Heading
                title={client.clientBusinessName}
                className='text-[16px] text-left text-bw08 font-metricRMedium'
              />
              {!client.needAccept && (
                <Heading title={client.ssnOrEIN} className='text-[14px] text-left text-bw07 font-metricR' />
              )}
            </div>
          </div>
          {client.needAccept && (
            <LiliButton
              className='min-w-[144px] leading-[12px] w-fit'
              id='accept-button'
              title={t('ACCOUNTANT_ACCOUNT_SWITCHER.ACCEPT_BUTTON')}
              disabled={isLoading}
              isLoading={isLoading}
              type={LiliButtonType.SECONDARY}
              onClick={(e) => {
                e.stopPropagation();
                if (onAcceptInvitationClick) onAcceptInvitationClick(client);
              }}
            />
          )}
          {!client.needAccept ? (
            itemMode === AccountantAccountSwitcherMode.PROFILE ? (
              <RadioButton className='' id='' title='' onClick={() => {}} checked={isChecked} />
            ) : (
              <RightArrow />
            )
          ) : (
            ''
          )}
        </div>
      }
    />
  );
};
